export const planitem = [
    {
        "anio" : "Formato para la Integración del PAAAS 2026",
        "url": "/pdf/FORMATO_PAAAS_2026.xlsx"
    },  
    {
        "anio" : "PAAAS 2026",
        "url": "/pdf/Formato_PAAAS2026.pdf"
    }, 
    {
        "anio" : "PAAAS 2025",
        "url": "/pdf/Formato_PAAAS2025.pdf"
    },
    {
        "anio" : "PAAAS 2024",
        "url": "/pdf/Formato_PAAAS2024.pdf"
    },
    {
        "anio" : "PAAAS 2023",
        "url": "/pdf/Formato_PAAAS2023.pdf"
    },
    {
        "anio" : "PAAAS 2022",
        "url": "/pdf/Formato_PAAAS2022.pdf"
    },
    {
        "anio" : "PAAAS 2021",
        "url": "/pdf/Formato_PAAAS2021.pdf"
    },
    {
        "anio" : "PAAAS 2020",
        "url": "/pdf/Formato_PAAAS2020.pdf"
    },
    {
        "anio" : "PAAAS 2019",
        "url": "/pdf/Formato_PAAAS2019.pdf"
    },
    {
        "anio" : "PAAAS 2018",
        "url": "/pdf/Formato_PAAAS2018.pdf"
    },
    
]